import { render } from "./VideoResources.vue?vue&type=template&id=66a2a40a&scoped=true"
import script from "./VideoResources.vue?vue&type=script&lang=js"
export * from "./VideoResources.vue?vue&type=script&lang=js"

import "./VideoResources.vue?vue&type=style&index=0&id=66a2a40a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a2a40a"]])

export default __exports__